import { Component, OnInit, Inject} from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { KeycloakService } from 'keycloak-angular';

@Component({
    selector: 'app-layout-user-profile-sheet',
    templateUrl: './user-profile-sheet.component.html'
})
export class LayoutUserProfileSheetComponent implements OnInit {

    model: any = {};

    constructor(
        private bottomSheetRef: MatBottomSheetRef<LayoutUserProfileSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data,
        private keycloakService: KeycloakService
    ) { }


    async ngOnInit() {
        this.model.user = this.data.user;
        this.model.partner = this.data.partner;
        this.model.account = this.data.account;
    }

    changeItem() {
        this.bottomSheetRef.dismiss();
        //item.preventDefault();
    }

    async logout() {
        await this.keycloakService.logout();
    }

}
